import { useEffect, useState } from "react";
import { useToast } from "../../toastHook"
import axios from 'axios'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api';
import { ConfirmModalComponent } from '../Utils/ConfirmModal'
 
export const ActiviteComponent = () => {

    const { display } = useToast();
    const [activites, setActivites] = useState();
    const [countSave, setCountSave] = useState(0);
    const [activiteToAdd, setActiviteToAdd] = useState('');

    useEffect(() => {
        axios.get('/api/activite/getall').then(
            response => setActivites(response.data.map(x => { return { activite: x }; })));
}, [countSave] );

    const [filters] = useState({
        activite: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [confirmAddOpen, setConfirmAddOpen] = useState(false);
    const [toDelete, setToDelete] = useState();

    const onRemoveActivite = activite => {
        axios.get('/api/activite/remove?activite=' + activite)
            .then(
                response => {
                    display({
                        titre: 'activite ajouté',
                        text: `l'activité '${activite}'' a été retirée avec succès`,
                        severity: 'success'
                    })

                    setCountSave(countSave + 1);
                });
    }

    const onAddActivite = activite => {

        if (!activite) {
            display({
                titre: 'mauvaise input',
                text: 'veuillez rentrer une activité',
                severity: 'info'
            })

            return;
        }

        axios.get('/api/activite/add?activite=' + activite)
            .then(
            response => {
                if (response.data.isSuccess) {
                    display({
                        titre: 'activite ajouté',
                        text: `l'activité '${activite} a été ajouté avec succès` ,
                        severity: 'success'
                    })

                    setActiviteToAdd('');
                    setCountSave(countSave + 1);
                }
                else
                {
                    display({
                        titre: 'activite non ajouté',
                        text: `l'activité '${ activite} n'a pas pu ête ajouté. Raison: ${response.data.reasonErrorMessage}'` ,
                        severity: 'danger'
                    })
                }
            });
            }


    const displayActivite = x => <div className="d-flex flex-row justify-content-between"><span>{x.activite}</span><i className="bi bi-x-circle text-danger" onClick={() => { setToDelete(x.activite); setConfirmDeleteOpen(true); }}></i></div>

return <div><div className="alert alert-info">
    Voici la liste des activités présentes sur la plateforme
</div>
    <ConfirmModalComponent open={confirmDeleteOpen} setOpen={setConfirmDeleteOpen} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer ${toDelete} , êtes-vous sure ? `} onConfirm={ () => onRemoveActivite(toDelete) } />
    <ConfirmModalComponent open={confirmAddOpen} setOpen={setConfirmAddOpen} titre="êtes vous sure d'insérer' ?" message={`Vous allez insérer ${activiteToAdd} , êtes-vous sure ? `} onConfirm={ () => onAddActivite(activiteToAdd) } />
    <div className="input-group">
    <input type="text" value={activiteToAdd} className="form-control" onChange={x => setActiviteToAdd(x.target.value)} /> 
        <button type="button" className="ms-2 btn btn-outline-success input-group-text" onClick={() => { if (activiteToAdd) { setConfirmAddOpen(true) }  }  } ><i className="pi pi-plus"></i> </button>
    </div>

    <DataTable value={activites} tableStyle={{ width: '100%' }}
        filters={filters}  filterDisplay="row">
        <Column field="activite" header="Activite" filterField="activite" filter sortable body={displayActivite} />
    </DataTable></div>
}




















